import { StudentForDiagnostic, UnassignDiagnosticLessonsVM, StudentForDiagnosticDetail, StudentForDiagnosticGradeList } from './../../../Elearning-Models';
import { SkippedStudentsDialogComponent } from './skipped-students-dialog/skipped-students-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DiagnosticVM } from 'src/app/Elearning-Models';
import { Component, OnInit, ViewChild } from '@angular/core';
import { IAPIService } from 'src/app/Services/API-Service/IAPIService';
import { DiagnosticsDataService } from 'src/app/Services/diagnosticsData.service';
import { IServiceFactory } from 'src/app/Services/service-factory';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { MatAccordion } from '@angular/material/expansion';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component';
import { AssignLessonsDialogComponent } from './assign-lessons-dialog/assign-lessons-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { ColorCodes } from '../../../ColorCodes';
import { DiagExamListDialogComponent } from './diag-exam-list-dialog/diag-exam-list-dialog.component';

@Component({
  selector: 'app-diagnostic-detail',
  templateUrl: './diagnostic-detail.component.html',
  styleUrls: ['./diagnostic-detail.component.scss']
})
export class DiagnosticDetailComponent implements OnInit {
  @ViewChild(MatAccordion) accordion: MatAccordion;
 
  diagnosticData:DiagnosticVM;
  diagnosticLoading: boolean = false;
  diagnosticExamID: number;
  lessonName: string;
  classID: number;
  className: string;
  isExpanded: boolean = true;

  studentsWithLessons: StudentForDiagnosticDetail[] = [];

  private diagnosticsDataService: DiagnosticsDataService;

  constructor(
    private serviceFactory: IServiceFactory,
    private APIService: IAPIService,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private toastr: ToastrService
  ) {
    this.diagnosticsDataService = this.serviceFactory.getDiagnosticsDataService();
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.diagnosticExamID = +params.get('id');
    });

    this.activatedRoute.queryParamMap.subscribe(queryParams => {
      this.className = queryParams.get('className');
      this.lessonName = queryParams.get('lessonName');
      this.classID = +queryParams.get('classID');
    });

    this.getDiagnosticData();
  }

  getDiagnosticData = () => {
    this.diagnosticLoading = true;
    this.APIService.GetDiagnosticDataByDiagnosticExamID(this.diagnosticExamID).subscribe((response: DiagnosticVM) => {
      this.diagnosticData = response;
      this.studentsWithLessons = response.StudentsWithLessons?.sort((a, b) => this.sortByLessonProgress(a,b));
      
      this.diagnosticLoading = false;
    });
  }

  sortByLessonProgress(a, b){
    var aLP = a.LessonsAssigned / a.LessonsCompleted;

    var bLP = b.LessonsAssigned / b.LessonsCompleted;

    var result = this.sortFunction(bLP, aLP);

    if(result == 0){
      return this.sortFunction(a.StudentName, b.StudentName);
    }
    else{
      return result;
    }
  }

  sortFunction(a, b){
    if(a < b){
      return -1;
    }
    else if(a > b){
      return 1;
    }
    else{
      return 0;
    }
  }

  onExpandAll = () => {
    this.accordion.openAll();
  }

  onCollapseAll = () => {
    this.accordion.closeAll();
  }

  onSkipUnassignedClick = (studentID: number, studentName: string) => {
    this.openConfirmDialog(1, 'Skip Student', 'Are you sure that you want to skip for '+studentName, studentID);
  }

  onAssignUnassignedClick = (studentID: number, studentName: string) => {
    this.openConfirmDialog(2, 'Assign Student', 'Are you sure that you want to assign to '+studentName, studentID);
  }

  onAssignAllUnassignedClick = () => {
    this.openConfirmDialog(3, 'Assign All Students', 'Are you sure that you want to assign to all the students');
  }

  onSkipAssignedClick = (studentID: number, studentName: string) => {
    this.openConfirmDialog(4, 'Skip Student', 'Are you sure that you want to skip for '+studentName, studentID);
  }

  onUnassignedLinkClick = () => {
    this.openSkippedStudentsDialog(1, 'Students Not Assigned to Diagnostic');
  }

  onAssignLessonsLinkClick = () => {
    this.openSkippedStudentsDialog(2, 'Students Not Assigned Lessons');
  }

  onAssignStudentLessons = (student: StudentForDiagnostic) => { // assign just one student their lessons
    this.openAssignLessonsDialog(1, 'Assign Diagnostics Lesson for '+student.StudentName, student.StudentID)
  }

  onAssignLessons = () => { // assign all students their lessons
    this.openAssignLessonsDialog(2, 'Assign Diagnostics Lesson for all the students');
  }

  onNotStarted(){
    this.openDiagExamListDiaglog('Diagnostic Exams Not Started', this.diagnosticData.StudentsNotStartedExam);
  }

  onInProgress(){
    this.openDiagExamListDiaglog('Diagnostic Exams In Progress', this.diagnosticData.StudentsExamInProgress);
  }

  skipUnassigned = (studentID: number) => {
    this.APIService.DiagnosticSkipStudent({
      DiagnosticExamID: this.diagnosticExamID,
      StudentID: studentID,
      Skip: true
    }).subscribe((response: boolean) => {
      if(response) {
        this.diagnosticData.StudentsUnassigned = this.diagnosticData.StudentsUnassigned.filter(student => student.StudentID !== studentID);
        this.toastr.success('Student Skipped', 'Success!');
      } else {
        this.toastr.error('Something went wrong', 'Failure!');
      }
    })
  }

  assignUnassigned = (studentID: number) => {
    this.APIService.AssignStudentDiagnostic({
      DiagnosticExamID: this.diagnosticExamID,
      StudentID: studentID
    }).subscribe((response: boolean) => {
      if(response) {
        this.diagnosticData.StudentsUnassigned = this.diagnosticData.StudentsUnassigned.filter(student => student.StudentID !== studentID);
        this.toastr.success('Student Assigned', 'Success!');
      } else {
        this.toastr.error('Something went wrong', 'Failure!');
      }
    })
  }

  assignAllUnassigned = () => {
    this.APIService.AssignAllDiagnostic({
      DiagnosticExamID: this.diagnosticExamID
    }).subscribe((response: boolean) => {
      if(response) {
        this.diagnosticData.StudentsUnassigned = [];
        this.toastr.success('All Students Assigned', 'Success!');
      } else {
        this.toastr.error('Something went wrong', 'Failure!');
      }
    })
  }

  releasedResults(response: boolean){
    if(response){
      this.toastr.success('All Assignments Released', 'Success!');
    } else {
      this.toastr.error('Something went wrong', 'Failure!');
    }
  }
  unassignedResults(model: UnassignDiagnosticLessonsVM){
    if(model) {
      if(model.AssignmentID){
        var sIndex = this.diagnosticData.StudentsWithLessons.findIndex(student => student.StudentID == model.StudentID);
        this.diagnosticData.StudentsWithLessons[sIndex].Assignments = this.diagnosticData.StudentsWithLessons[sIndex]?.Assignments
        .filter(assignment => assignment.AssignmentID !== model.AssignmentID);

        if(this.diagnosticData.StudentsWithLessons[sIndex]?.Assignments.length == 0)
        {
          this.diagnosticData.StudentsWithLessons = this.diagnosticData.StudentsWithLessons?.filter(student => student.StudentID !== model.StudentID);
        }
      }
      else{
        this.diagnosticData.StudentsWithLessons = this.diagnosticData.StudentsWithLessons?.filter(student => student.StudentID !== model.StudentID);
      }
     
      this.toastr.success('Student Unassigned', 'Success!');
    } else {
      this.toastr.error('Something went wrong', 'Failure!');
    }
  }

  skipAssigned = (studentID: number) => {
    this.APIService.DiagnosticLessonsSkipStudent({
      DiagnosticExamID: this.diagnosticExamID,
      StudentID: studentID,
      Skip: true,
      AAYieldNoILP: false
    }).subscribe((response: boolean) => {
      if(response) {
        var student = this.diagnosticData.StudentsawaitingILP.find(s => s.StudentID == studentID);
        this.diagnosticData.StudentsLessonSkipList.push(student);
        this.diagnosticData.StudentsawaitingILP = this.diagnosticData.StudentsawaitingILP.filter(student => student.StudentID !== studentID);
        

        this.toastr.success('Student Skipped', 'Success!');
      } else {
        this.toastr.error('Something went wrong', 'Failure!');
      }
    });
  }

  removeFromSkip = (selectedStudents: StudentForDiagnostic[]) => {
    let selectedStudentIDs: number[] = [];
    selectedStudents.map(student => selectedStudentIDs.push(student.StudentID));
    this.APIService.DiagnosticRemoveFromSkipStudent({
      DiagnosticExamID: this.diagnosticExamID,
      StudentID: selectedStudentIDs
    }).subscribe((response: boolean) => {
      if(response) {
        this.diagnosticData.StudentsUnassigned = [...this.diagnosticData.StudentsUnassigned, ...selectedStudents];
        this.toastr.success((selectedStudents.length === 1 ? 'Student ' : 'Students ') + 'Removed from Skip', 'Success!');
      } else {
        this.toastr.error('Something went wrong', 'Failure!');
      }
    });
  }

  removeFromLessonsSkip = (selectedStudents: StudentForDiagnostic[]) => {
    let selectedStudentIDs: number[] = [];
    selectedStudents.map(student => selectedStudentIDs.push(student.StudentID));
    this.APIService.DiagnosticRemoveFromLessonsSkipStudent({
      DiagnosticExamID: this.diagnosticExamID,
      StudentID: selectedStudentIDs
    }).subscribe((response: boolean) => {
      if(response) {
        this.diagnosticData.StudentsawaitingILP = [...this.diagnosticData.StudentsawaitingILP, ...selectedStudents];
        this.diagnosticData.StudentsLessonSkipList = this.diagnosticData.StudentsLessonSkipList?.filter(s => !selectedStudents.includes(s));
        // since we call this from the dummy record for yielded no ilp students, it filters them out of the list to remove them from the dummy 
        this.diagnosticData.StudentsYieldedNoILP = this.diagnosticData.StudentsYieldedNoILP?.filter(s => selectedStudents.includes(s));
        this.toastr.success((selectedStudents.length === 1 ? 'Student ' : 'Students ') + 'Removed from Skip', 'Success!');
      } else {
        this.toastr.error('Something went wrong', 'Failure!');
      }
    });
  }

  assignStudentLessons = (studentID: number, assignOptions) => {
    this.APIService.AssignStudentDiagnosticLessons({
      DiagnosticExamID: this.diagnosticExamID,
      StudentID: studentID,
      StartDate: assignOptions.StartDate,
      EndDate: assignOptions.EndDate,
      RemoveExtendedResponseOption: assignOptions.RemoveExtendedResponseOption,
      AssignFromOption: assignOptions.AssignFromOption
    }).subscribe((response: boolean) => {
      if(response) {
        this.diagnosticData.StudentsawaitingILP = this.diagnosticData.StudentsawaitingILP.filter(student => student.StudentID !== studentID);
        this.toastr.success('Student Assigned', 'Success!');
      } else {
        this.toastr.error('Something went wrong', 'Failure!');
      }
    })
  }

  assignLessons =  (assignOptions) => {
    this.APIService.AssignDiagnosticLessons({
      DiagnosticExamID: this.diagnosticExamID,
      StartDate: assignOptions.StartDate,
      EndDate: assignOptions.EndDate,
      RemoveExtendedResponseOption: assignOptions.RemoveExtendedResponseOption,
      AssignFromOption: assignOptions.AssignFromOption
    }).subscribe((response: boolean) => {
      if(response) {
        this.diagnosticData.StudentsawaitingILP = [];
        this.toastr.success('All Students Assigned', 'Success!');
      } else {
        this.toastr.error('Something went wrong', 'Failure!');
      }
    })
  }

  openConfirmDialog = (method: number, title: string, text: string, studentID?: number) => {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: title,
        text: text
      },
      autoFocus: false,
    });

    const sub = dialogRef.componentInstance.confirmSelected.subscribe(
      (confirmSelected) => {
        switch(method) {
          case 1: {
            this.skipUnassigned(studentID);
            break;
          }
          case 2: {
            this.assignUnassigned(studentID);
            break;
          }
          case 3: {
            this.assignAllUnassigned();
            break;
          }
          case 4: {
            this.skipAssigned(studentID);
            break;
          }
        }

      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      sub.unsubscribe();
    });
  }

  WhichSkipList(method: number){
    switch(method){
      case 1: {
        return [];
      }
      case 2:{
        return this.diagnosticData.StudentsLessonSkipList;
      }
    }
  }
  openDiagExamListDiaglog(title: string, students: StudentForDiagnosticGradeList[]){
    const dialogRef = this.dialog.open(DiagExamListDialogComponent, {
      data: {
        title,
        students
      },
      autoFocus: false,
    });
  }

  openSkippedStudentsDialog = (method: number ,title: string) => {
    const dialogRef = this.dialog.open(SkippedStudentsDialogComponent, {
      data: {
        method,
        title,
        diagnosticExamID: this.diagnosticExamID,
        students: this.WhichSkipList(method)
      },
      autoFocus: false,
    });

    

    const sub = dialogRef.componentInstance.removeClicked.subscribe(
      (selectedStudents: StudentForDiagnostic[]) => {
        switch(method) {
          case 1: {
            this.removeFromSkip(selectedStudents);
            break;
          }
          case 2: {
            this.removeFromLessonsSkip(selectedStudents);
            break;
          }
        }
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      sub.unsubscribe();
    });
  }

  openAssignLessonsDialog = (method: number, title: string, studentID?: number) => {
    const dialogRef = this.dialog.open(AssignLessonsDialogComponent, {
      data: {
        title
      },
      autoFocus: false,
    });

    const sub = dialogRef.componentInstance.assignLessonsConfirmed.subscribe(
      (assignOptions) => {
        switch(method) {
          case 1: { // assign 1 student
            this.assignStudentLessons(studentID, assignOptions);
            break;
          }
          case 2: { // assign all students
            this.assignLessons(assignOptions);
            break;
          }
        }
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      sub.unsubscribe();
    });
  }
}
